import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
import isTouchDevice from "is-touch-device";
import useHover from "../../../../lib/player/src/hooks/useHover";

const useStyles = createUseStyles(theme => ({
  container: {
    width: "100%",
    overflow: "hidden",
    "overflow-x": props =>
      isTouchDevice() || props.hovering ? "auto" : "hidden",
  },
  tabs: {
    width: "max-content",
    "min-width": "calc(100% - 10px)",
    "border-bottom": "1px solid #707070",
    display: "flex",
    "flex-direction": "row",
    "padding-left": 10,
    height: 40,
  },
  tab: {
    color: "white",
    cursor: "pointer",
    position: "relative",
    top: 1,
    padding: [3, 15, 5],
    margin: [0, 5],
    "font-size": 18,
    "flex-shrink": 0,
    "border-bottom": "1px solid transparent",
    transition: "border 0.1s ease",

    "&:hover": {
      "border-bottom": "2px solid #ccc",
    },
  },
  notTab: {
    extend: "tab",
    cursor: "auto",
    "border-bottom": "2px solid #ccc",
    "text-transform": "uppercase",
  },
  active: {
    color: theme.colorRed,
    "border-bottom": `3px solid ${theme.colorRed} !important`,
  },
}));

const Tabs = ({ searching, tab, setActive, team }) => {
  const [ref, hovering] = useHover();
  const classes = useStyles({ hovering });

  return (
    <div className={classes.container} ref={ref}>
      <div className={classes.tabs}>
        {searching ? (
          <>
            <div
              onClick={() => setActive("Tours")}
              className={clsx(classes.tab, {
                [classes.active]: tab === "Tours",
              })}
            >
              Tours
            </div>
            <div
              onClick={() => setActive("Accounts")}
              className={clsx(classes.tab, {
                [classes.active]: tab === "Accounts",
              })}
            >
              Accounts
            </div>
          </>
        ) : (
          <div className={clsx(classes.notTab)}>{team}</div>
        )}
      </div>
    </div>
  );
};

export default Tabs;
